import { render, staticRenderFns } from "./CreateRbuItemDialog.vue?vue&type=template&id=2e6bd04d"
import script from "./CreateRbuItemDialog.vue?vue&type=script&lang=js"
export * from "./CreateRbuItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports